import React from "react";

interface Props {
  size: number;
}

export const LogoIcon: React.FC<Props> = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 236 236"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="132.561"
        y="55.5837"
        width="79.4738"
        height="127.726"
        rx="11.9683"
        transform="rotate(25 132.561 55.5837)"
        fill="#ECE6FE"
      />
      <rect
        x="71.6385"
        y="43.7797"
        width="79.4738"
        height="127.726"
        rx="11.9683"
        fill="#CCC3FC"
      />
      <rect
        x="33.449"
        y="87.0876"
        width="79.4738"
        height="127.726"
        rx="11.9683"
        transform="rotate(-25 33.449 87.0876)"
        fill="#7C71FC"
      />
      <path
        d="M82.8255 139.602C79.7948 139.665 77.7264 135.244 79.7003 132.943C82.0775 130.172 84.3662 126.997 85.4627 124.049C86.5192 121.208 86.7358 117.105 86.6298 113.291C86.547 110.312 90.7122 108.313 92.97 110.259C95.8968 112.781 99.247 115.258 102.094 116.294C104.943 117.331 109.104 117.587 112.97 117.535C115.949 117.496 117.858 121.704 115.881 123.934C113.318 126.823 110.799 130.167 109.729 133.108C108.718 135.886 108.466 139.768 108.53 143.443C108.583 146.474 104.178 148.508 101.9 146.508C99.1522 144.095 96.0409 141.794 93.2665 140.784C90.4683 139.766 86.539 139.524 82.8255 139.602Z"
        fill="white"
      />
    </svg>
  );
};
